"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const User_1 = require("./models/User");
class UserService {
    /**
        * Returns a new UserService instance
        * @param {ng.IHttpService}            private $http    [description]
        * @param {common.services.Toolbox}    private toolbox  [description]
        */
    constructor($http, toolbox) {
        this.$http = $http;
        this.toolbox = toolbox;
        this.baseUrl = 'Api/Users';
    }
    /**
        * Returns the current authenticated user
        */
    getCurrentUser() {
        return this.currentUser;
    }
    isUserLoggedIn() {
        if (this.currentUser) {
            return this.currentUser.isLoggedIn();
        }
        else {
            return false;
        }
    }
    removeCurrentUser() {
        this.currentUser = null;
        return true;
    }
    /**
    * Resolves the current user.
    */
    resolveCurrentUser() {
        var url = this.toolbox.createRequestUrl(this.baseUrl + '/Current');
        return this.$http.get(url).then(response => {
            var user = new User_1.User(response.data);
            this.currentUser = user;
            return user;
        });
    }
}
exports.UserService = UserService;
UserService.$inject = ['$http', 'toolbox'];
